<template>
  <ModalConfirmAction
    title="Excluir Perfil Aprovador"
    message="Tem certeza que deseja excluir este perfil de aprovador?"
    confirmText="Excluir"
    :loading="loading"
    @confirm="deletePerfilAprovador"
  >
    <template #activator="{ on, attrs }">
      <div class="table-action-box table-action-delete" v-bind="attrs" v-on="on">
        <v-icon small>mdi-delete-outline</v-icon>
        <span class="table-action-label">Excluir</span>
      </div>
    </template>
  </ModalConfirmAction>
</template>

<script>
import { apiClient } from "@/services/api";
import ModalConfirmAction from "../ModalConfirmAction.vue";

export default {
  components: { ModalConfirmAction },
  props: {
    cod_aprovador_perfil: Number,
    fetchData: Function,
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    async deletePerfilAprovador() {
      try {
        this.loading = true;
        const response = await apiClient.delete(
          `removerAprovadorPerfilSocialCam/${this.cod_aprovador_perfil}`
        );
        if (response.status === 200) {
          this.$toast.success(response.data);
          await this.fetchData();
        }
      } catch (error) {
        this.$toast.error(error.response.data.error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
